import {useContext} from 'react'

import ProductFiltersContext from '../../ProductFiltersContext'

export default function useProductFiltersContext() {
  const context = useContext(ProductFiltersContext)

  return context
}
